const cookieStorage = require('../utils/cookie-storage');
const defaultApp = 'desygner';
let currentVersion;
let currentApp;

module.exports = {
  isEqual: function (version) {
    return compare(version) === 0;
  },
  isLowerThan: function (version) {
    return compare(version) > 0;
  },
  isGreaterThan: function (version) {
    return compare(version) < 0;
  },
  get: function () {
    return currentVersion = currentVersion || cookieStorage.get('ver');
  },
  getApp: function () {
    return currentApp = currentApp || cookieStorage.get('app_name') || defaultApp;
  },
  isApp: function (app) {
    currentApp = currentApp || cookieStorage.get('app_name') || defaultApp;
    return app === currentApp;
  }
};

function compare (version) {
  currentVersion = currentVersion || cookieStorage.get('ver');

  if (typeof version + typeof currentVersion != 'stringstring') {
    return false;
  }

  const a = version.split('.');
  const b = currentVersion.split('.');
  let i = 0;
  const len = Math.max(a.length, b.length);

  for (; i < len; i++) {
    if ((a[i] && !b[i] && parseInt(a[i]) > 0) || (parseInt(a[i]) > parseInt(b[i]))) {
      return 1;
    } else if ((b[i] && !a[i] && parseInt(b[i]) > 0) || (parseInt(a[i]) < parseInt(b[i]))) {
      return -1;
    }
  }

  return 0;
}
